import axios from "axios"
let localLogin = localStorage.getItem("lastLoginInfo");
import qs from "qs"
import {setUrlParam} from '@/plugins/utils'
//将对象转为input标签
const parseObjToInput = function (Obj) {
    let div = document.createElement("div");
    if (typeof Obj == "object") {
        for (let k in Obj) {
            let input = document.createElement("input");
            input.setAttribute("name", k);
            input.setAttribute("value", Obj[k])
            div.appendChild(input);
        }
    }
    return div;
}
// 历史登录
const historyLogin = function (ActionUrl, targetUrl) {
    return new Promise(async resolve => {
        let hash = window.location.hash
        hash = hash.split("?")[1]
        if (hash && hash.indexOf("#") != -1) hash = hash.substring(0, hash.indexOf("#"))
        hash = qs.parse(hash);
        if (hash.logout == 1) {
            localStorage.removeItem("lastLoginInfo")
            // 注销后就清除一遍以前没区分公总号的 openId, 有可能是错的。从此保存正确的名称 openId+schoolId...
            localStorage.removeItem("openId")
            return resolve();
        }
        if (hash.schoolId) {
            localStorage.setItem("schoolId", hash.schoolId)
        }
        if (hash.targetUrl) {
            sessionStorage.setItem("targetUrl", hash.targetUrl)
        }
        if (hash.openId) {
            //每一个学校对应不同的 oepnId
            localStorage.setItem("openId" + (hash.schoolId || 1), hash.openId)
        }
        // console.log(typeof(hash.openId), 'dsad', hash.openId ,'------', hash.test===undefined, '========');
        //无schoolId 自动登录验证失败
        if (!localStorage.getItem("schoolId")) {
            localStorage.setItem("schoolId", 1);
            return resolve()
        }
        try {
            //本地登录信息
            localLogin = JSON.parse(decodeURIComponent(localLogin))
            // if (localLogin && Date.now() - (localLogin.lastLoginTime || 0) <= 7 * 24 * 60 * 60 * 1000 && ActionUrl[localLogin.nowRole]) {
            if (localLogin && ActionUrl[localLogin.nowRole]) {
                let data = {
                    schoolId: localStorage.getItem("schoolId"),
                    mobile: localLogin.mobile,
                    studentCode: localLogin.mobile
                }
                //最后一次登录身份不为学生拉取最后一次登录身份
                if (localLogin.nowRole !== "student") {
                    let lastRoleRet = await axios({
                        method: "post",
                        url: process.env.VUE_APP_BASE_URL + "/login/last-login-log",
                        data,
                        headers: {
                            schoolId: localStorage.getItem("schoolId")
                        }
                    }).catch(e => {
                        console.log(e)
                    }) || {}
                    if (lastRoleRet.status == 200 && lastRoleRet.data.code == 0) {
                        localLogin.nowRole = lastRoleRet.data.content.LastLogin
                    } else {
                        return resolve();
                    }
                }
                localLogin.targetUrl = targetUrl[localLogin.nowRole]
                //测试是否正常登录的测试表单
                let formData = new FormData();
                for (let k in localLogin) {
                    if (localLogin[k] && k != "targetUrl") formData.append(k, localLogin[k])
                }
                try {
                    formData.set("targetUrl", "")
                    formData.set("schoolId", localStorage.getItem("schoolId"));
                    if (localLogin.nowRole == "student") {
                        formData.delete("mobile")
                    }
                    if (localLogin.nowRole != "student") {
                        formData.delete("studentCode")
                    }
                } catch (error) {
                    console.log(error);
                }
                let testLogin = await axios({
                    method: "post",
                    url: ActionUrl[localLogin.nowRole],
                    data: formData
                }).catch(e => {
                    console.log(e)
                }) || {}
                // 测试登录成功 从定向链接
                if (testLogin.data.code == 0) {
                    const localTarget = sessionStorage.getItem('targetUrl');
                    if(localTarget && localTarget !== 'undefined') {
                        const token = testLogin.data.content && testLogin.data.content.token;
                        sessionStorage.removeItem('targetUrl');
                        window.location.href = setUrlParam(localTarget, 'token', token);
                        return;
                    }
                    //  this.loginData.targetUrl = localTarget;
                    
                    localLogin.lastLoginTime = Date.now();
                    localStorage.setItem("lastLoginInfo", encodeURIComponent(JSON.stringify(localLogin)))
                    let form = document.createElement("form");
                    form.setAttribute("action", ActionUrl[localLogin.nowRole])
                    form.setAttribute("enctype", "application/x-www-form-urlencoded")
                    form.setAttribute("method", "post")
                    form.appendChild(parseObjToInput(localLogin));
                    form.setAttribute("style", "position:absolute;height:0;width:0;overflow:hidden;")
                    document.body.appendChild(form);
                    form.submit();
                }
            }
        } catch (error) {
            console.log(error)
        }
        resolve();
    })

}
export default historyLogin